import type { NodeV2 } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'
import { useCallback, useState } from 'react'
import React from 'react'

import Tabs, { TabPanel } from 'components/uiKit/Tabs'
import { setProjectNavigation } from 'services/Store/Project/actions'
import { AppMode } from 'services/Store/Project/enums'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getEditorMode } from 'services/Store/Project/selectors'
import type { Block, IBlockMode, MapType } from 'services/Store/Project/types'
import { t } from 'services/Translation'

import * as s from './Picker.module.scss'
import TabAsset from './TabAsset'
import TabElements from './TabElements'
import TabFrame from './TabFrame'
import TabStash from './TabStash'

enum TabsEnum {
  NODES = 'nodes',
  ELEMENTS = 'elements',
  STASH = 'stash',
}
const TABS = [
  { value: 'elements', title: t('editorV2.elements'), Component: TabElements },
  { value: 'asset', title: t('editorV2.asset'), Component: TabAsset },
  { value: 'frame', title: t('editorV2.frame'), Component: TabFrame },
  { value: 'stash', title: t('editorV2.stash'), Component: TabStash },
]

interface IPickerProps {
  onAdd: (
    node: NodeV2,
    data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> },
  ) => void
  mode: IBlockMode
  block: Block
  node: NodeV2
}

const Picker: React.FC<IPickerProps> = ({ block, node, onAdd }) => {
  const dispatch = useProjectDispatch()
  const [tab, setTab] = useState(TabsEnum.ELEMENTS)
  const isPro = useProjectContext(getEditorMode) === AppMode.pro

  const tabs = isPro ? TABS : TABS.filter((t) => t.value !== 'frame')

  const handleAdd = useCallback(
    (node: NodeV2, data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> }) => {
      onAdd(node, data)
      dispatch(setProjectNavigation({ nodeIds: [node.id] }))
    },
    [dispatch, onAdd],
  )

  return (
    <div className={s.root}>
      <Tabs activeKey={tab} name='tabs' onChange={setTab}>
        {tabs.map(({ value, title, Component }) => (
          <TabPanel key={value} tabKey={value} title={title}>
            <Component block={block} onAdd={handleAdd} parent={node} />
          </TabPanel>
        ))}
      </Tabs>
    </div>
  )
}

export default React.memo(Picker)
